import { DataSource, Label, Layout, Table, } from "@mcleod/components";

export abstract class AutogenLayoutCompareOrder2 extends Layout {
    labelToBeUsedWithCompareOrderLean: Label;
    sourceEdiCompareGroup: DataSource;
    sourceEdiCompareItem: DataSource;
    tableChangeGroups: Table;
}
